import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import dns from "../../Assets/Projects/DNS.png";
import dnsFlow from "../../Assets/Projects/DNS-structure.png";
import game2048 from "../../Assets/Projects/2048.png";
import iso from "../../Assets/Projects/ISO.png";
import chatbot from "../../Assets/Projects/chatbot.png";
import chatbotFlow from "../../Assets/Projects/aoai-web.png";
import webGIS from "../../Assets/Projects/webGIS1.png";
import stadium from "../../Assets/Projects/stadium.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stadium}
              isBlog={false}
              title="Stadium Matching System"
              description="The system matches the users to join the activity based on the user's location and the stadium's capacity. Built with React, Node.js, MySQL, and deployed on Azure Kubernetes Service."
              ghLink="https://github.com/106207411/Stadium-Matching-System"
              demoLink="https://stadium.rdto.io"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatbot}
              isBlog={false}
              title="Chatbot For Enterprise"
              description="Chatbot website which intergates enterprise data and uses Azure OpenAI to answer employees' questions. Built with Redis, PostgreSQL and C# and deployed on Azure App Service."
              SysDesignLink={chatbotFlow}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={iso}
              isBlog={false}
              title="ISO27001 Assessment"
              description="Accelerated ISO 27001 KPI assessment by capturing screenshots of targeted applications and archive files to Amazon S3 with API Gateway."
              ghLink="https://github.com/106207411/ISO27001-Assessment-Automation"
              demoLink="https://youtu.be/TxR_XGbL9Jg"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dns}
              isBlog={false}
              title="DNS Record Management"
              description="Designed and implemented an application form using Jira to gather DNS record information from staff members.
              Improving process efficiency by 80% for developing a serverless architecture using AWS Lambda, API Gateway, RDS, and KMS to automate DNS record management tasks."
              demoLink="https://youtu.be/sbZflSSZ9No"
              SysDesignLink={dnsFlow}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={webGIS}
              isBlog={false}
              title="Yunlin Traveling Web"
              description="Built travel websites for Yunlin and features like autocomplete searching, user comment uploaded, and shortest path planning. Using leaflet.js, mapbox.js, Google Map API, jQuery, PHP, and MySQL."
              ghLink="https://github.com/106207411/Yunlin-Travel-Web"
              demoLink="https://user.sgis.tw/yunlin-travel/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={game2048}
              isBlog={false}
              title="Advanced 2048 Game"
              description="Advanced 2048 game using C++ SFML"
              ghLink="https://github.com/106207411/PD-FinalProject"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
